import React, {Component} from 'react';
import {FormGroup, Row, Col, Grid, ControlLabel} from 'react-bootstrap';
import {connect} from 'react-redux';
import {Form, actions} from 'react-redux-form';
import ArrowButton from '../common/button-arrow';
import Datepicker from '../common/form/datepicker';
import SearchableSelect from '../common/form/elements/searchable-select';

class Filter extends Component {
  getFilterData = () => {
    const { form } = this.props;
    return {
      outlet_id: form.outlet_id.value,
      transaction_type: form.transaction_type.value,
      date_from: form.date_from.value,
      date_to: form.date_to.value,
    };
  };

  handleClearFilters = () => {
    const { dispatch } = this.props;
    dispatch(actions.reset('deep.points_statement'));
    this.handleSubmit();
  };

  handleSubmit = () => {
    const { applyFilters } = this.props;
    applyFilters(this.getFilterData());
  };

  handleDownload = () => {
    const { download } = this.props;
    download();
  };

  getStoreOptions = () => {
    const { stores } = this.props;
    return [].concat(...stores.map(outlets => ({value: outlets.attributes['customer-number'], label: outlets.attributes.name})));
  };

  transactionTypes = [
    { value: 'credit', label: 'Credit' },
    { value: 'debit', label: 'Debit' },
  ];

  render() {
    const { form } = this.props;

    if (form === undefined) {
      return null;
    }

    return (
      <Grid fluid style={ { paddingTop: '2em' } }>
        <Form
          className="points-statement-tabs-personal-filter-form"
          model='deep.points_statement'
          onSubmit={this.handleSubmit}
        >
          <Row>
            <Col xs={12}>
              <ArrowButton arrow={false} onClick={this.handleDownload}>Download all transactions</ArrowButton>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <FormGroup controlId="outlet_id">
                <SearchableSelect
                  label='Store'
                  model='deep.points_statement.outlet_id'
                  options={this.getStoreOptions()}
                  value={form.outlet_id.value}
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <FormGroup controlId="transaction_type">
                <SearchableSelect
                  label='Transaction type'
                  model='deep.points_statement.transaction_type'
                  options={this.transactionTypes}
                  value={form.transaction_type.value}
                  required
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel>Date range</ControlLabel>
              <Datepicker
                model="deep.points_statement.date_from"
                controlId="date_to"
                value={form.date_from.value}
              />
            </Col>
            <Col sm={6}>
              <ControlLabel style={ { height: '1em' } }></ControlLabel>
              <Datepicker
                model="deep.points_statement.date_to"
                controlId="date_to"
                value={form.date_to.value}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="points-statement-tabs-personal-filter-form-buttons">
              <ArrowButton arrow={false} onClick={this.handleClearFilters}>Clear</ArrowButton>
              <ArrowButton arrow={false} submit>Apply filters</ArrowButton>
            </Col>
          </Row>
        </Form>
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  form: state.deep.forms.points_statement
});


export default connect(mapStateToProps)(Filter);



// WEBPACK FOOTER //
// ./src/components/points-statement/filter.jsx